// post-t7-2b (A1, #613): la version del Aviso de Privacidad que se acepta al unirse a un grupo. Es la fecha de
// entrada en vigor del aviso; las tres puertas de unirse la mandan en el cuerpo de `POST /groups/join` y el
// servidor la compara con la suya (`AVISO_PRIVACIDAD_VERSION` de `backend/routes/groups.py`; una prueba del
// backend compara las dos fuentes). Si cambia el aviso, cambian las dos a la vez.
export const AVISO_PRIVACIDAD_VERSION = '2026-10-14';
